import { render } from "./DocRequestContent.vue?vue&type=template&id=26b3bb43"
import script from "./DocRequestContent.vue?vue&type=script&lang=js"
export * from "./DocRequestContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__